import useGooglePay from '@fhs-legacy/frontend/src/state/google-pay/hooks/use-google-pay';

export function usePaymentProcessor() {
  const cart = { rbiOrderId: undefined };
  const { requestingPayment } = useGooglePay({
    rbiOrderId: cart?.rbiOrderId ?? '',
  });

  return {
    isPending: requestingPayment,
    // eslint-disable-next-line
    makePaymentAndCommit: () => console.log('committing order'),
  };
}
